module.exports = __webpack_public_path__ + "media/icons/back-arrow-1b08db8542aa2252708af164032a14fb.svg";